import { render } from "./BalanceValue.vue?vue&type=template&id=3ac53964&scoped=true"
import script from "./BalanceValue.vue?vue&type=script&lang=js"
export * from "./BalanceValue.vue?vue&type=script&lang=js"

import "./BalanceValue.vue?vue&type=style&index=0&id=3ac53964&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac53964"]])

export default __exports__